import { render, staticRenderFns } from "./LuExciseTransactionTypeDialog.vue?vue&type=template&id=24a7b34a&"
import script from "./LuExciseTransactionTypeDialog.vue?vue&type=script&lang=js&"
export * from "./LuExciseTransactionTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports